import { render, staticRenderFns } from "./app-register-sent.vue?vue&type=template&id=f4738b84&scoped=true"
import script from "./app-register-sent.vue?vue&type=script&lang=js"
export * from "./app-register-sent.vue?vue&type=script&lang=js"
import style0 from "./app-register-sent.vue?vue&type=style&index=0&id=f4738b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4738b84",
  null
  
)

export default component.exports